/* eslint-disable complexity */
import React, { FC, useCallback } from 'react';
import { Box, IconButton, Modal } from '@mui/material';
import CloseIcon from '@mui/icons-material/CloseRounded';
import { OrderDto } from '@sweatpals/shared';
import Logo from '../../ui-v2/logo/logo.component';
import { EventBundleFormProps, EventBundleForm } from './event-bundle-form.component';

export interface EventBundleFormModalProps extends EventBundleFormProps {
	isOpen: boolean;
	onClose(): void;
}

export const EventBundleFormModal: FC<EventBundleFormModalProps> = props => {
	const {
		isOpen,
		onClose,
		onSubmit,
		...eventBundleFormProps
	} = props;

	const handleSubmit = useCallback(async (order?: OrderDto): Promise<void> => {
		await onSubmit?.(order);
		onClose();
	}, [onClose, onSubmit]);

	return (
		<Modal open={isOpen}>
			<EventBundleForm
				{...eventBundleFormProps}
				onSubmit={handleSubmit}
				Header={({ clearSelectedEventBundleId }) => (
					<Box display="flex" alignItems="center" justifyContent="space-between">
						<Logo type="light" sx={{ cursor: 'default', height: '21px' }} layout="fill" />

						<IconButton
							sx={{
								color: '#FFFFFF',
								border: '1px solid #FFFFFF66',
								width: '48px',
								height: '48px',
							}}
							onClick={() => {
								onClose();
								clearSelectedEventBundleId();
							}}
						>
							<CloseIcon />
						</IconButton>
					</Box>
				)}
			/>
		</Modal>
	);
};
